export default [
  {
    title: 'Parte de horas',
    route: 'partesOperario',
    icon: 'ClockIcon',
  },
  {
    title: 'Usuarios',
    route: 'users',
    icon: 'UsersIcon',
  },
  {
    title: 'Trazabilidad',
    route: 'traceabilities',
    icon: 'ActivityIcon',
  },
  {
    title: 'Departamentos',
    route: 'departments',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'Gestión',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Calendario laboral',
        route: 'calendario',
      },
      {
        title: 'Datos empresa',
        route: 'config',
      },
      {
        title: 'Política de registro horario',
        route: 'policy',
      },
    ],
  },
]
